import PermissionManagementList from "components/system-management/permission-management/list";
import { createContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadListAction } from "redux/reducers/permission-management/list";

export const PermissionManagementContext = createContext();

export default function PermissionManagement(props) {
  const dispatch = useDispatch();
  const { params, managerRoleList } = useSelector(
    (state) => state.permissionManagement
  );

  const loadList = (params) => {
    dispatch(loadListAction(params));
  };

  return (
    <>
      <PermissionManagementContext.Provider
        value={{ loadList, params, managerRoleList, props }}
      >
        <main id="main">
          <PermissionManagementList />
        </main>
      </PermissionManagementContext.Provider>
    </>
  );
}
